import { Formik, Form } from 'formik';
import * as Yup from 'yup'

import Axios from 'axios';
import PmsUrlConfig from '../../urlConfig';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import ServiceLocation from './ServiceLocationComponent';
import { handleServiceTypeChange, logout, setAuthToken, getServiceTypesById } from '../common';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* eslint-disable */
export default function AddServiceLocation({ updateFlag, onSuccess }) {
    const dispatch = useDispatch();
    const practiceDetails = useSelector(state => state.practiceDetails);

    if (!practiceDetails)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />


    const loginDetails = useSelector(state => state.loginDetails);
    var serviceTypes = [];
    var token = "";
    if (loginDetails) {
        serviceTypes = loginDetails.serviceTypes;
        token = loginDetails.jwtToken;
    }


    const clearMultiSelect = () => {
        // if(selectInputRef && selectInputRef.current && selectInputRef.current.select){
        //     console.log("Clearing SELECT")
        //     selectInputRef.current.select.clearValue();
        // }
    };
    const practice = practiceDetails.practice;
    if (!practice)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;
    const practiceId = practice._id;


    const addressSchema = Yup.object().shape({
        locationName: Yup.string().required('Required!'),
        addServiceStreet1: Yup.string().required('Required!'),
        addServiceCity: Yup.string().required('Required!'),
        addServiceState: Yup.string().required('Required!'),
        addServiceZipcode: Yup.string().required('Required!')
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
        pmsServiceType: Yup.array().min(1, 'At least one department is required').of(Yup.object().shape({
            label: Yup.string().required('Required!'),
            value: Yup.string().required('Required!'),
        })),
    })




    return (
        <div className="w-full max-w-4xl mx-auto p-4 sm:p-6">
            <Formik
                initialValues={{
                    locationName: '',
                    addServiceStreet1: '',
                    addServiceStreet2: '',
                    addServiceCity: '',
                    addServiceState: '',
                    addServiceZipcode: '',
                    pmsServiceType: [{ 'label': "", 'value': "" }]
                }}
                validationSchema={addressSchema}
                onSubmit={(values, { resetForm, setSubmitting }) => {
                    var addServiceUrl = PmsUrlConfig.BOS_ADD_SERVICE_URL + practiceId;
                    setAuthToken(token);
                    Axios.post(addServiceUrl,
                        {
                            location_name: values.locationName,
                            service_address: {
                                street1: values.addServiceStreet1,
                                street2: values.addServiceStreet2,
                                city: values.addServiceCity,
                                state: values.addServiceState,
                                zip_code: values.addServiceZipcode,
                            },
                            service_types: getServiceTypesById(serviceTypes, practiceDetails.selectedServiceTypes.map(st => st.value))
                        }
                    ).then((response) => {
                        console.log('Response status:', response.status);
                        console.log('Response data:', response.data);
                        
                        if (response.status === 200) {
                            toast.success('Service location added successfully!', {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            resetForm()
                            dispatch({
                                type: 'addServiceSuccess',
                                payload: response.data
                            })
                            // Call onSuccess callback to close modal
                            if (onSuccess) {
                                onSuccess();
                            }
                        }
                        else if (response.status === 400) {
                            setSubmitting(false);
                            const errorMessage = response.data?.error_code?.description || 'Server error occurred';
                            toast.error(errorMessage, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: errorMessage
                            })
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        setSubmitting(false);
                        console.log("error------------>", error)
                        const errorMessage = error.response?.data?.error_code?.description || error.message || 'Server error occurred';
                        toast.error(errorMessage, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                        if (error.response?.data?.error_code) {
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: errorMessage
                            })
                        } else if (error.response?.status === 401 || error.response?.status === 403) {
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: "Unauthorized operation performed"
                            })
                        } else {
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: errorMessage
                            })
                        }
                    })
                }}
                onReset={() => {

                    dispatch({
                        type: 'clearMsg'
                    });
                    dispatch({
                        type: 'clearServiceType'
                    })
                    clearMultiSelect();
                }}
            >
                {({ errors, touched, values, handleChange, isSubmitting, handleReset, resetForm, setSubmitting, handleBlur, setFieldValue }) => (
                    <Form id="addServiceLocation_form" className="space-y-6">
                        <div className="w-full">
                            <ServiceLocation
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                handleReset={handleReset}
                                setSubmitting={setSubmitting}
                                isSubmitting={isSubmitting}
                                successMsg={successMsg}
                                errorMsg={errorMsg}
                                handleServiceTypeChange={handleServiceTypeChange}
                                serviceTypes={serviceTypes}
                                updateFlag={updateFlag}
                                setFieldValue={setFieldValue}
                                prefix={'addService'}
                                dispatch={dispatch}
                            />
                        </div>
                        
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-start sm:justify-end">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-6 py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                            >
                                {isSubmitting ? "Adding.." : "Add"}
                            </button>
                            <button
                                type="button"
                                onClick={handleReset}
                                className="px-6 py-2 bg-gray-100 border border-teal-300 hover:bg-gray-200 text-teal-600 font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                            >
                                Reset
                            </button>
                        </div>
                    </Form>
                )}

            </Formik>
        </div>
    )

}